<script setup lang="ts">
const props = defineProps<{
  gamificationName: string;
  gamificationCoinName: string;
}>();
</script>

<template>
  <div class="content-section-main-level-content">
    <div class="content-section-main-level-title">
      <p>
        <span>{{ $t('gamification.levels.welcome_levels_area') }}</span>
      </p>
    </div>
    <div class="content-section-main-level-description">
      <p>
        <span
          v-html="
            $t('gamification.levels.description_line1', {
              gamificationName: props.gamificationName,
            })
          "
        ></span>
      </p>
      <p>
        <span
          v-html="
            $t('gamification.levels.description_line2', {
              gamificationCoinName: props.gamificationCoinName,
            })
          "
        ></span>
      </p>
      <p>
        <span
          v-html="
            $t('gamification.levels.description_line3', {
              gamificationName: props.gamificationName,
            })
          "
        ></span>
      </p>
    </div>
    <div class="content-section-title-bg-content">
      <h4 class="content-section-title-bg">
        <span>{{ $t('gamification.levels.level_up_increase_earnings') }}</span>
      </h4>
    </div>
  </div>
</template>

<style lang="postcss">
.content-section-main-level-content {
  @apply py-4 px-5 md:py-6 md:px-8;

  .content-section-main-level-title {
    h1 {
      @apply mb-3 md:mb-6 text-texts text-base md:text-2xl font-bold;
    }
  }

  .content-section-main-level-description {
    @apply max-h-[150px] md:max-h-none mb-4 md:mb-0 overflow-x-hidden overflow-y-auto;

    p {
      @apply mb-3 text-texts text-xs md:text-base leading-5 md:leading-6;
    }
  }

  .content-section-title-bg-content {
    .content-section-title-bg {
      @apply bg-button-bg text-button-text px-2 py-2 md:px-5 md:py-3 rounded inline-flex font-bold text-xs md:text-base w-full md:w-auto text-center justify-center items-center;
    }
  }
}
</style>
